<template>
  <div>
    <el-table border :data="data" style="width: 500px;">
      <el-table-column type="index" label="序号" />
      <el-table-column label="功能" prop="FunType">
        <template slot-scope="{row}">
          <span v-if="row.FunType == 0">购销存</span>
          <span v-if="row.FunType == 1">往来</span>
          <span v-if="row.FunType == 2">出纳</span>
        </template>
      </el-table-column>
      <el-table-column label="启用会计期间" prop="FunDate">
        <template slot-scope="{row}">
          <el-date-picker v-model.trim="row.FunDate" type="month" placeholder="请选择日期" value-format="yyyy-MM-dd"
            @change="onChange(row)" style="width: 180px;"></el-date-picker>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      api: require('@/api/sy/funSetting').default,
      data: []
    }
  },
  methods: {
    getData() {
      this.api.list({}).then(res => {
        if (res.Code == 0) {
          this.data = res.Data;
        }
      })
    },
    onChange(row) {
      console.log(JSON.parse(JSON.stringify(row)));
      var loading = this.$loading({
        lock: true,
        text: "正在保存...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.save(row).then(() => {
        loading.close();
      });
    }
  }
}
</script>